import { IForm } from 'core-components/classes/models/IForm'

import { IContactsWithMultiplePartners } from '../../features/models/contactsWithMultiplePartners'

export const mapContactsWithMultiplePartnersFromCrud = (
  data: IForm[]
): IContactsWithMultiplePartners[] =>
  data.map((source: IForm) => ({
    contactId: source.contactId || '',
    email: source.email || '',
    partnerId: source.partnerId || '',
  }))
